import moment from 'moment';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getLastRefreshDate } from '../LatencyService';
import { getISTDate } from '../../../../../Shared/common';
import { DEFAULT_SWITCH_FILTER } from '../deviceStates';

const LatencyContext = createContext();

export const LatencyContextProvider = ({ children }) => {

    const [GlobalFilter, setGlobalFilters] = useState({
        search: [],
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        city: [],
        depot: [],
        contract: [],
        // Device Health switches (Mains / Ignition / Emergency), flipped from the table header
        ...DEFAULT_SWITCH_FILTER
    });

    const [lastRefreshDate, setLastRefreshDate] = useState(null);

    useEffect(() => {
        getLastRefreshDate()
            .then(res => {
                let date = moment(res?.lastRefreshDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
                setLastRefreshDate(res?.lastRefreshDate || null)
                setGlobalFilters(prev => ({
                    ...prev,
                    startDate: getISTDate(date),
                    endDate: getISTDate(date)
                }))
            }).catch(err => {})
    }, [])

    return (
        <LatencyContext.Provider value={{ GlobalFilter, setGlobalFilters, lastRefreshDate }}>
            {children}
        </LatencyContext.Provider>
    );
};

export const useLatencyContextData = () => useContext(LatencyContext);
